<template>
  <div class="flex flex-col">
    <div class="mb-4 flex items-start">
      <textarea
        class="growing form-textarea flex-1"
        :placeholder="this.$t('activity_contacts.notes.create_placeholder')"
        v-model="newNote"
      ></textarea>
      <button
        class="btn btn-outline-primary btn-sm ml-2"
        @click="createNote"
        :disabled="!newNote.trim()"
      >
        {{ $t('activity_contacts.notes.submit') }}
      </button>
    </div>
    <div v-for="note in notes" :key="note.id" class="mt-4">
      <div class="flex items-center text-sm text-gray-500">
        <div>
          {{ formatDate(note.created_at) }}
        </div>
        <span
          class="far fa-times ml-2 cursor-pointer p-1 text-gray-500 hover:text-black"
          @click="removeNote(note)"
        ></span>
      </div>
      <div v-text="note.note" class="pre-wrap"></div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  props: {
    contactId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      notes: [],
      newNote: '',
    }
  },
  methods: {
    createNote() {
      axios
        .post('/api/contacts/' + this.contactId + '/notes', {
          note: this.newNote,
        })
        .then(({ data }) => {
          this.notes.unshift(data)
          this.newNote = ''
          this.$el.querySelector('textarea').style.height = null
        })
        .catch((error) => {
          console.log(error)
        })
    },
    removeNote(note) {
      if (!confirm(this.$t('activity_contacts.notes.confirm_deletion'))) {
        return
      }

      axios
        .delete('/api/contact-notes/' + note.id)
        .then(({ data }) => {
          this.notes = this.notes.filter((existingNote) => {
            return existingNote.id != note.id
          })
        })
        .catch((error) => {
          console.log(error)
        })
    },
    formatDate(date) {
      let calendar = moment(date).calendar(null, {
        sameElse: 'LL',
      })
      return calendar.charAt(0).toUpperCase() + calendar.slice(1)
    },
  },
  created() {
    axios
      .get('/api/contacts/' + this.contactId + '/notes')
      .then(({ data }) => {
        this.notes = data
      })
      .catch((error) => {
        console.log(error)
      })
  },
}
</script>
